import { createContext } from 'react';

const AuthContext = createContext();
const AppContext = createContext();

export { AuthContext, AppContext };
